import React from 'react';
import { AmbientBackground } from './components/AmbientBackground';
import { MouseExplosion } from './components/MouseExplosion';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { ProblemSection } from './components/ProblemSection';
import { BenefitsSection } from './components/BenefitsSection';
import { IndustryShowcase } from './components/IndustryShowcase';
import { SocialProof } from './components/SocialProof';
import { ProcessTimeline } from './components/ProcessTimeline';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Chatbot } from './components/Chatbot';
import { IntroAnimation } from './components/IntroAnimation';
export function App() {
  return <div className="relative w-full min-h-screen selection:bg-electric/30 selection:text-white" data-id="element-0">
      <IntroAnimation data-id="element-1" />
      <AmbientBackground data-id="element-2" />
      <MouseExplosion data-id="element-3" />
      <Nav data-id="element-4" />

      <main data-id="element-5">
        <Hero data-id="element-6" />
        <TrustStrip data-id="element-7" />
        <ProblemSection data-id="element-8" />
        <BenefitsSection data-id="element-9" />
        <IndustryShowcase data-id="element-10" />
        <SocialProof data-id="element-11" />
        <ProcessTimeline data-id="element-12" />
        <Testimonials data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
      <Chatbot data-id="element-17" />
    </div>;
}